'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _ListItem = require('../List/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('MenuItem', function (theme) {
  var palette = theme.palette,
      typography = theme.typography,
      transitions = theme.transitions;

  return {
    root: theme.mixins.truncate(Object.assign({}, typography.body1, {
      paddingTop: 0,
      paddingBottom: 0,
      height: typography.rhythmByUnit(5),
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      transition: transitions.create('background-color', {
        duration: transitions.duration.short
      }),
      '&:focus, &:hover': {
        backgroundColor: palette.accent['200']
      }
    })),
    selected: {
      backgroundColor: palette.text.divider
    }
  };
});

var MenuItem = (_temp = _class = function (_PureComponent) {
  _inherits(MenuItem, _PureComponent);

  function MenuItem() {
    _classCallCheck(this, MenuItem);

    return _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));
  }

  _createClass(MenuItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            component = _props.component,
            selected = _props.selected,
            role = _props.role,
            other = _objectWithoutProperties(_props, ['className', 'component', 'selected', 'role']);

        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.selected, selected), classNameProp);
        var listItemProps = {};

        if (!component) {
          listItemProps.ripple = false;
        }

        return _react2['default'].createElement(_ListItem2['default'], _extends({
          button: true,
          selected: true,
          tabIndex: '-1'
        }, Object.assign({ className: className, component: component, role: role }, listItemProps, other)));
      }

      return render;
    }()
  }]);

  return MenuItem;
}(_react.PureComponent), _class.muiName = 'MenuItem', _class.propTypes = {
  /**
   * Menu item contents.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * @ignore
   */
  role: _PropTypes2['default'].string,
  /**
   * Use to apply selected styling.
   */
  selected: _PropTypes2['default'].bool
}, _class.defaultProps = {
  role: 'menuitem',
  selected: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = MenuItem;


MenuItem.displayName = 'MenuItem';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Menu/MenuItem.js
// module id = 1670
// module chunks = 32